const button = {
    boxSizing: 'border-box',
    borderRadius: '5px',
    color: 'secondary.dark',
    fontSize: '1rem',
    lineHeight: '20px',
    maxHeight: '52px',
    padding: '10px',
    width: '100%',
    '&:active': {
        boxShadow: '0 0 1px 0 rgba(0,0,0,0.31), 0 5px 8px -2px rgba(0,0,0,0.25)',
    },
};
export const primary = {
    ...button,
    backgroundColor: 'primary.contrastText',
    '&:hover': {
        boxShadow: '0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)',
        backgroundColor: 'primary.contrastText',
    },
    padding: '1rem',
};
export const secondary = {
    ...button,
    backgroundColor: '#fff',
    border: '2px solid ',
    borderColor: 'secondary.dark',
    padding: '1rem',
    '&:hover': {
        boxShadow: '0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)',
    },
};
export const disabled = {
    ...button,
    backgroundColor: '#C3C3C3',
    color: 'secondary.dark',
    '&:hover': {
        backgroundColor: '#C3C3C3',
    },
    '&:disabled': {
        color: 'secondary.dark',
    },
    padding: '1rem',
};
const custom = {
    boxSizing: 'border-box',
    borderRadius: '5px',
    color: 'secondary.dark',
    fontSize: '1rem',
    lineHeight: '20px',
    maxHeight: '52px',
    padding: '10px',
    '&:active': {
        boxShadow: '0 0 1px 0 rgba(0,0,0,0.31), 0 5px 8px -2px rgba(0,0,0,0.25)',
    },
    backgroundColor: 'primary.contrastText',
    '&:hover': {
        boxShadow: '0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)',
        backgroundColor: 'primary.contrastText',
    },
};
export default {
    primary,
    secondary,
    disabled,
    custom,
};
